 <section id="about" >
  <div class="container">
  <header class="section-header">
    <h1 class="section-title" style="text-align: center;">Retail Banking Software</h1>
  </header>
  <div class="row row-eq-height justify-content-center">
      <div class="row about-container">

        
          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           
            <div class="icon-box wow fadeInUp">
              <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Customer ID Creation</a></h4>
              <p class="description">Every Customer has unique ID creation and insert there details.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Shares</a></h4>
              <p class="description">Maintain Share account open, Share Allotment /

                Transfer - Through Vouchers,Share Certificate Printing,Dividend Calculations and Warrant Printing,Automatic credit of Dividends.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Deposits</a></h4>
              <p class="description">Create new deposit types, Deposit account creation, Deposit Interest Calculation,Maturity Etc.
                </p>
            </div>

            <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Loans</a></h4>
                <p class="description">Create New Loan type, Account Creation, Interest Calculation, Defaulter List Etc. </p>
              </div>

              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Other Reports</a></h4>
                  <p class="description">Day-Book / Subsidiaries,
                    Profit Loss Account,
                    Balance Sheet with Group Facilities,
                    Trial Balance,
                    General Ledger,
                    Day Book,
                    Statement of Account - Personal Accounts,
                                
                    
                    
                    </p>
                </div>
                <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Pigmy and Rikring</a></h4>
                  <p class="description">Pigmy / Rikring Account Creation, 
                    Daily collection, 
                    Interest Calculation, 
                    Pigmy Register - For Complete Month,.
                    </p>
                </div>
                <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Standing Instructions</a></h4>
                  <p class="description">Standing Instruction Creation,
                      Standing Instruction Executed,
                      Standing Instruction Unexecuted,
                      
                    </p>
                </div>
              
          </div>
         


          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           

            <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Loan Reports</a></h4>
                <p class="description">Monthly / Quarterly / Half Yearly / Annual Interest Calculation List,
                                      Overdue Loan List,NOC Certificate,
                                      Defaulter List,Interest Certificates,
                                      Loan Guaranter Register.
                  </p>
              </div>

              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Deposit Reports</a></h4>
                  <p class="description">Monthly / Quarterly / Half Yearly / Annual Interest Calculation List,
                     Interest Certificates, Deposit Receipts, Deposit Maturity List.
                    </p>
                </div>
                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Dead Stock and Reports </a></h4>
                    <p class="description">Dead Stock Account Creation, 
                                           Depreciation Calculation, 
                                           Depreciation Reports. </p>
                  </div>
                  <div class="icon-box wow fadeInUp">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">Insurance </a></h4>
                      <p class="description">Insurance Maturity list,
                          Investment Maturity List,
                          
                                                  </p>
                    </div>
    
                    <div class="icon-box wow fadeInUp">
                        <div class="icon"><i class="fa fa-check-circle"></i></div>
                        <h4 class="title"><a href="">Auto Email and Backup facility</a></h4>
                        <p class="description">You will get auto email and Auto Backup facility.
                          </p>
                      </div>
                      <div class="icon-box wow fadeInUp">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Employees Security Module</a></h4>
                          <p class="description">Employee can use software as per their authority.
                            </p>
                        </div> 
                      <div class="icon-box wow fadeInUp">
                        <div class="icon"><i class="fa fa-check-circle"></i></div>
                        <h4 class="title"><a href="">For Salary Earners</a></h4>
                        <p class="description">Preparation of Demand note,
                             Receive/Transfer as per cutting sheet,
                             Monthly Cutting sheet history,
                             Monthly Vargani, share, recurring
                             transfer and related reports,
                             Daily / Monthly Basis Interest
                             calculation and transfer,
                             Members Yearly Balancing Report,
                             Member wise all account detail report.
                          </p>
                      </div>
                                         


                         
          </div>
        </div>

        
    </div>
</div>
</section>